"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProductForm = void 0;
var common_1 = require("../constants/form/common");
var tailwind_1 = require("../constants/tailwind");
var contents_1 = require("../constants/form/contents");
/**
 * 商品検索フォームのクラス
 * 商品検索フォームの初期化とイベントハンドリングを行うクラス
 */
var SearchProductForm = /** @class */ (function () {
    /**
     * コンストラクタ
     * @param {SearchProductElements} elements 商品検索フォームの要素群
     * @param {SearchProductCallbacks} callbacks コールバック関数群
     */
    function SearchProductForm(elements, callbacks) {
        if (callbacks === void 0) { callbacks = {}; }
        this.elements = elements;
        /**
         * 商品検索フォームの初期化状態
         * 初期化済みかどうかを示すフラグ
         */
        this.initialized = false;
        this.callbacks = callbacks;
        this.initProductSearchFormEvent();
        this.initResetButtonClickEvent();
        this.checkFormState();
    }
    /**
     * フォームの状態をチェックし初期化
     * 各inputのチェック状態に応じた処理を実行
     */
    SearchProductForm.prototype.checkFormState = function () {
        var _a;
        var _this = this;
        var formData = new FormData(this.elements.form);
        var formNameList = window.eccube.formNameList;
        // チェックがついているinputに応じた処理を定義
        var strategies = (_a = {},
            _a[formNameList.productType] = function (inputEl) { return _this.handleProductTypeRadioChange(inputEl, false); },
            _a[formNameList.warningHazardParent] = function (inputEl) { return _this.handleSymbolMarkSelectChange(inputEl.value); },
            _a);
        Object.values(formNameList).forEach(function (value) {
            var formValue = formData.get(value);
            if (!formValue)
                return;
            var checkedInput = _this.elements.form.querySelector("[value=\"".concat(formValue, "\"]"));
            if (!checkedInput)
                return;
            // チェックがついているinputに応じて、処理を実行
            var fn = strategies[value];
            if (typeof fn === 'function') {
                fn(checkedInput);
            }
        });
    };
    /**
     * 商品検索フォームのチェンジイベント
     */
    SearchProductForm.prototype.initProductSearchFormEvent = function () {
        var _this = this;
        var formNameList = window.eccube.formNameList;
        this.elements.form.addEventListener('change', function (e) {
            var target = e.target;
            switch (target === null || target === void 0 ? void 0 : target.name) {
                case formNameList.productType: {
                    _this.handleProductTypeRadioChange(target);
                    break;
                }
                case formNameList.warningHazardParent: {
                    _this.handleSymbolMarkSelectChange(target.value);
                    break;
                }
                default:
                    break;
            }
        });
        var menuClickedEvent = new CustomEvent('menu-clicked-event');
        document.addEventListener('click', function (e) {
            var target = e.target;
            switch (target === null || target === void 0 ? void 0 : target.id) {
                case contents_1.CONTENTS_SEARCH_IDS.PARENT_CATEGORY: {
                    document.dispatchEvent(menuClickedEvent);
                    break;
                }
                case contents_1.CONTENTS_SEARCH_IDS.CHILD_SYMBOL_MARK: {
                    document.dispatchEvent(menuClickedEvent);
                    break;
                }
                default:
                    break;
            }
        });
    };
    /**
     * リセットボタンのクリックイベントを初期化
     */
    SearchProductForm.prototype.initResetButtonClickEvent = function () {
        this.elements.resetButton.addEventListener('click', this.handleResetButtonClick.bind(this));
    };
    /**
     * リセットボタンクリックイベントの処理
     */
    SearchProductForm.prototype.handleResetButtonClick = function () {
        var _a, _b;
        this.resetForm();
        (_b = (_a = this.callbacks).onReset) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * フォームをリセット
     */
    SearchProductForm.prototype.resetForm = function () {
        if (!this.initialized) {
            // 初回のリセット時はフォームを初期化
            this.elements.form.reset();
            this.initialized = true;
        }
        else {
            this.clearForm();
        }
        this.toggleChildSymbolMarkDisabled(true);
        this.updateChildSymbolMarkOptions();
    };
    /**
     * フォームをすべてクリア
     */
    SearchProductForm.prototype.clearForm = function () {
        var inputs = this.elements.form.querySelectorAll('input:checked');
        var selects = this.elements.form.querySelectorAll('select');
        var searchInput = this.elements.form.querySelector('input[type="search"]');
        inputs.forEach(function (input) {
            input.checked = false;
        });
        selects.forEach(function (select) {
            select.selectedIndex = 0;
        });
        if (searchInput) {
            searchInput.value = '';
        }
    };
    /**
     * 商品タイプラジオボタンのチェンジイベントの処理
     * @param {HTMLInputElement} target 選択されたラジオボタン
     */
    SearchProductForm.prototype.handleProductTypeRadioChange = function (target, triggerCallback) {
        var _a, _b;
        if (triggerCallback === void 0) { triggerCallback = true; }
        // id="header-keyword" の現在値を保存
        var headerKeywordInput = document.getElementById('header-keyword');
        var headerKeywordValue = headerKeywordInput ? headerKeywordInput.value : undefined;
        this.resetForm();
        // id="header-keyword" の値を復元
        if (headerKeywordInput && headerKeywordValue !== undefined) {
            headerKeywordInput.value = '';
        }
        // 商品タイプの警告ラベルカテゴリのID
        var warningLabelId = window.eccube.productCategoryIds.warningLabel;
        if (target.value === warningLabelId) {
            this.elements.warningOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            this.elements.laserOptions.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        }
        else {
            this.elements.warningOptions.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            this.elements.laserOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        }
        target.checked = true;
        // コールバック実行（初期化時は実行しない）
        if (triggerCallback) {
            if (headerKeywordInput && headerKeywordValue !== undefined) {
                headerKeywordInput.value = headerKeywordValue;
            }
            (_b = (_a = this.callbacks).onProductTypeChange) === null || _b === void 0 ? void 0 : _b.call(_a, target.value);
        }
    };
    /**
     * シンボルマークセレクトボックスの変更イベントの処理
     * @param {string} value 選択された親シンボルマークのカテゴリ
     */
    SearchProductForm.prototype.handleSymbolMarkSelectChange = function (value) {
        var waringHazardCategories = window.eccube.warningHazardCategories;
        var selectedCategory = waringHazardCategories[value];
        this.updateChildSymbolMarkOptions(selectedCategory);
    };
    /**
     * 子シンボルマークセレクトボックスの使用可否を切り返る
     * @param {boolean} disabled 使用不可にするかどうか
     */
    SearchProductForm.prototype.toggleChildSymbolMarkDisabled = function (disabled) {
        if (disabled) {
            this.elements.childSymbolMark.disabled = true;
            this.elements.childSymbolMark.classList.add(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            this.elements.childSymbolMarkArrow.classList.add(tailwind_1.TAILWIND_CLASSES.PSEUDO_AFTER_ARROW_DISABLED);
        }
        else {
            this.elements.childSymbolMark.disabled = false;
            this.elements.childSymbolMark.classList.remove(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            this.elements.childSymbolMarkArrow.classList.remove(tailwind_1.TAILWIND_CLASSES.PSEUDO_AFTER_ARROW_DISABLED);
        }
    };
    /**
     * 子シンボルマークセレクトボックスのオプションを更新
     * @param {ECCubeGlobal['warningHazardCategories'][string]} selectedCategory 選択された親シンボルマークのカテゴリー
     */
    SearchProductForm.prototype.updateChildSymbolMarkOptions = function (selectedCategory) {
        var _this = this;
        this.elements.childSymbolMark.innerHTML = '';
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var warningHazardChildValue = urlParams.get('warning_hazard_child');
        if (selectedCategory) {
            this.toggleChildSymbolMarkDisabled(false);
            Object.values(selectedCategory).forEach(function (category) {
                var option = document.createElement('option');
                option.value = category.id || '';
                if (category.id == warningHazardChildValue) {
                    option.selected = true;
                }
                option.textContent = category.name;
                _this.elements.childSymbolMark.appendChild(option);
            });
        }
        else {
            this.toggleChildSymbolMarkDisabled(true);
            var defaultOptions = document.createElement('option');
            defaultOptions.textContent = common_1.WARNING_HAZARD_CHILD_DEFAULT_TEXT;
            this.elements.childSymbolMark.appendChild(defaultOptions);
        }
    };
    /**
     * レーザラベルのサブカテゴリーに対応するラジオボタンを作成
     * @param {LaserSubCategories} laserSubCategories レーザラベルのサブカテゴリー
     */
    SearchProductForm.prototype.createLaserSubCategoryRadio = function (laserSubCategories) {
        var _a;
        var _this = this;
        var subCategoryKeys = Object.keys(laserSubCategories);
        // 各サブカテゴリごとのラジオボタンを作成するハンドラー
        var handlers = (_a = {},
            _a[common_1.LASER_SUB_CATEGORIES.CLASS_RANKS] = function () {
                return _this.createRadioElement(_this.elements.laserClassRanksContainer, common_1.LASER_SUB_CATEGORIES.CLASS_RANKS, laserSubCategories.classRanks);
            },
            _a[common_1.LASER_SUB_CATEGORIES.TYPES] = function () {
                return _this.createRadioElement(_this.elements.laserTypesContainer, common_1.LASER_SUB_CATEGORIES.TYPES, laserSubCategories.types);
            },
            _a[common_1.LASER_SUB_CATEGORIES.WAVELENGTHS] = function () {
                return _this.createRadioElement(_this.elements.laserWavelengthContainer, common_1.LASER_SUB_CATEGORIES.WAVELENGTHS, laserSubCategories.wavelengths);
            },
            _a);
        // 各サブカテゴリーのキーに対応するハンドラーを実行
        subCategoryKeys.forEach(function (key) {
            if (!_this.isLaserSubCategoryKey(key))
                return;
            handlers[key]();
        });
    };
    /**
     * 型ガード関数
     * 渡されたキーがレーザラベルのサブカテゴリーのキーかどうかを判定する
     * @param {string} key レーザラベルのサブカテゴリーのキー
     */
    SearchProductForm.prototype.isLaserSubCategoryKey = function (key) {
        return Object.values(common_1.LASER_SUB_CATEGORIES).includes(key);
    };
    /**
     * レーザラベルラジオボタンの作成
     * @param {HTMLElement} container ラジオボタンを配置するコンテナ
     * @param {LaserSubCategoryKeys} key レーザラベルのサブカテゴリーのキー
     * @param {CategoryList} categoryList レーザラベルのサブカテゴリーのリスト
     */
    SearchProductForm.prototype.createRadioElement = function (container, key, categoryList) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var laserRadioValue = urlParams.get(common_1.LASER_SUB_CATEGORIES_FORM_NAMES[key]);
        container.innerHTML = Object.values(categoryList).reduce(function (template, category) {
            var isChecked = category.id == laserRadioValue ? 'checked' : '';
            return (template +
                "\n        <label class=\"".concat(tailwind_1.TAILWIND_CLASSES.RADIO_WRAPPER, "\">\n          <input type=\"radio\" name=\"").concat(common_1.LASER_SUB_CATEGORIES_FORM_NAMES[key], "\" value=\"").concat(category.id, "\" id=\"").concat(key, "_").concat(category.id, "\" ").concat(isChecked, ">\n          <span>").concat(category.name, "</span>\n        </label>\n      "));
        }, '');
    };
    return SearchProductForm;
}());
exports.SearchProductForm = SearchProductForm;
